// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SYSTEM-WIDE theme modernization for legacy product pages.
 * Applies design tokens to all dashboard surfaces so every page
 * inherits Midnight / Cloudlight without per-page rewrites.
 */

/* ─── Universal product surfaces ─── */
.rt2-main,
.rt2-main * {
  border-color: inherit;
}

.rt2-main .bg-white,
.rt2-main .bg-gray-50,
.rt2-main .bg-gray-100,
.rt2-main .bg-slate-50,
.rt2-main .bg-slate-100 {
  background-color: var(--surface) !important;
}

.rt2-main .text-gray-900,
.rt2-main .text-gray-800,
.rt2-main .text-slate-900,
.rt2-main .text-black {
  color: var(--text-primary) !important;
}

.rt2-main .text-gray-700,
.rt2-main .text-gray-600,
.rt2-main .text-gray-500,
.rt2-main .text-slate-600,
.rt2-main .text-slate-500 {
  color: var(--text-secondary) !important;
}

.rt2-main .border-gray-200,
.rt2-main .border-gray-300,
.rt2-main .border-slate-200 {
  border-color: var(--border) !important;
}

.rt2-main .hover\\:bg-gray-50:hover,
.rt2-main .hover\\:bg-gray-100:hover,
.rt2-main .hover\\:bg-slate-50:hover {
  background-color: var(--surface-hover) !important;
}

.rt2-main input:not([type='checkbox']):not([type='radio']):not([type='range']),
.rt2-main select,
.rt2-main textarea {
  background-color: var(--input-background, var(--surface)) !important;
  color: var(--text-primary) !important;
  border-color: var(--input-border, var(--border)) !important;
}

.rt2-main input::placeholder,
.rt2-main textarea::placeholder {
  color: var(--input-placeholder, var(--text-secondary)) !important;
}

/* ─── Legacy buttons → RT look ─── */
.rt2-main .navbar-button,
.rt2-main .btn,
.rt2-main button.secondary,
.rt2-main .import-jira-btn,
.rt2-main .create-project-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.rt2-main .navbar-button.primary,
.rt2-main .btn-primary,
.rt2-main .create-project-btn {
  background: var(--primary, #2563eb) !important;
  color: #fff !important;
  border: 1px solid transparent !important;
}

.rt2-main .navbar-button.secondary,
.rt2-main .btn-outline,
.rt2-main .btn-secondary,
.rt2-main .import-jira-btn {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border) !important;
}

.rt2-main .generate-all-scenarios-btn,
.rt2-main .generate-all-tests-btn,
.rt2-main .generate-tests-btn,
.rt2-main .generate-scenarios-btn,
.rt2-main .sync-btn,
.rt2-main .view-tests-btn,
.rt2-main .regenerate-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  border: 1px solid var(--border) !important;
  background: var(--surface) !important;
  color: var(--text-primary) !important;
}

.rt2-main .generate-all-tests-btn,
.rt2-main .generate-tests-btn,
.rt2-main .sync-btn {
  background: color-mix(in srgb, var(--primary, #2563eb) 14%, var(--surface)) !important;
  border-color: color-mix(in srgb, var(--primary, #2563eb) 35%, var(--border)) !important;
  color: var(--primary, #2563eb) !important;
}

.rt2-main .generate-all-scenarios-btn,
.rt2-main .generate-scenarios-btn {
  background: color-mix(in srgb, #f59e0b 12%, var(--surface)) !important;
  border-color: color-mix(in srgb, #f59e0b 35%, var(--border)) !important;
  color: #d97706 !important;
}

[data-theme="dark"] .rt2-main .generate-all-scenarios-btn,
[data-theme="dark"] .rt2-main .generate-scenarios-btn {
  color: #fbbf24 !important;
}

/* ─── Tables ─── */
.rt2-main table,
.rt2-main .projects-table,
.rt2-main .workspaces-table,
.rt2-main .schedule-table {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.rt2-main thead,
.rt2-main th {
  background: var(--table-header, var(--bg-tertiary)) !important;
  color: var(--text-secondary) !important;
  border-color: var(--border) !important;
}

.rt2-main td {
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

.rt2-main tbody tr:hover {
  background: var(--table-hover, var(--surface-hover)) !important;
}

.rt2-main .projects-table-container,
.rt2-main .table-container,
.rt2-main .overflow-x-auto.rounded-lg,
.rt2-main .overflow-x-auto {
  background: var(--surface) !important;
  border-color: var(--border) !important;
}

/* ─── Cards / panels ─── */
.rt2-main .card,
.rt2-main .settings-card,
.rt2-main .report-card,
.rt2-main .metric-card,
.rt2-main .rounded-md.bg-white,
.rt2-main .rounded-lg.bg-white,
.rt2-main .rounded-xl.bg-white {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  box-shadow: var(--shadow-sm) !important;
  color: var(--text-primary) !important;
}

/* Elevation utilities: tint only — do NOT force borders onto every shadowed node
   (that previously boxed text/labels that happened to carry shadow-sm). */
.rt2-main .shadow-sm,
.rt2-main .shadow {
  box-shadow: var(--shadow-sm) !important;
}

/* ─── Status / priority pills keep semantic color but rest on tokens ─── */
.rt2-main .status-tabs,
.rt2-main .jira-items-tabs {
  background: var(--surface) !important;
  border-color: var(--border) !important;
}

.rt2-main .tab-btn,
.rt2-main .status-tab {
  color: var(--text-secondary) !important;
}

.rt2-main .tab-btn.active,
.rt2-main .status-tab.active {
  color: var(--primary, #2563eb) !important;
}

/* ─── Page-specific roots ─── */
.schedule-plan-container,
.environment-container,
.environment-list,
.test-data-list,
.project-test-plan-container,
.report-page-container,
.reports-container,
.learning-system,
.optimization-container,
.all-workspaces-container,
.projects-container,
.jira-items-overlay,
.jira-items-container,
.epics-stories-container,
.requirement-upload-page {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
}

/* Environment / Test data Tailwind shells */
.rt2-main .w-full.p-4.bg-white,
.rt2-main .w-full.p-6.bg-white {
  background: var(--surface) !important;
  border: 1px solid var(--border);
  border-radius: 12px;
  color: var(--text-primary) !important;
}

/* ─── Embeds under PageScaffold: hide duplicate titles ─── */
.rt-legacy-embed .projects-title,
.rt-legacy-embed .projects-subtitle,
.rt-legacy-embed .report-page-title,
.rt-legacy-embed .report-title,
.rt-legacy-embed .report-subtitle,
.rt-legacy-embed .settings-header,
.rt-legacy-embed .dashboard-welcome,
.rt-legacy-embed .epics-stories-header h1,
.rt-legacy-embed .epics-stories-header .epics-stories-subtitle,
.rt-legacy-embed .requirement-upload-page > h1,
.rt-legacy-embed .requirement-upload-page > .page-subtitle,
.rt-projects-embed .projects-title,
.rt-projects-embed .projects-subtitle {
  display: none !important;
}

.rt-legacy-embed .jira-items-overlay,
.rt-legacy-embed .jira-items-container {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  z-index: auto !important;
  height: auto !important;
  min-height: 0 !important;
  background: transparent !important;
  margin: 0 !important;
  padding: 0 !important;
}

.rt-legacy-embed .jira-items-container > .back-btn,
.rt-legacy-embed .back-btn {
  display: none !important;
}

/* Schedules: drop nested chrome + full-screen padding */
.rt-schedules-embed > .bg-gray-50 {
  background: transparent !important;
  padding: 0 !important;
  overflow: visible !important;
}

.rt-schedules-embed .min-h-screen {
  min-height: 0 !important;
}

.rt-schedules-embed > .bg-gray-50 > .max-w-full > .bg-white.rounded-lg.shadow-sm.border.border-gray-200.mb-6:first-child {
  display: none !important;
}

.rt-schedules-embed h1.text-xl,
.rt-schedules-embed h1.text-2xl {
  display: none !important;
}

/* Environments / Test Data: scaffold owns title + back */
.rt-env-embed > div > button[data-testid='back-to-projects-btn'],
.rt-env-embed h2.text-lg,
.rt-testdata-embed h2.text-lg,
.rt-env-form-embed > div > button,
.rt-env-form-embed h1.text-2xl,
.rt-env-form-embed h1 + p {
  display: none !important;
}

.rt-env-embed > div.w-full,
.rt-testdata-embed > div.w-full,
.rt-env-form-embed > div.w-full {
  padding: 0 !important;
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
}

.rt-env-embed .flex.items-center.justify-between.mb-4 {
  justify-content: flex-end;
}

.rt-workspaces-embed .workspaces-heading > h1,
.rt-workspaces-embed .workspaces-heading > p {
  display: none !important;
}

.rt-workspaces-embed .all-workspaces-container {
  padding: 0 !important;
  background: transparent !important;
}

/* Modals stay above shell */
.rt2-main .fixed.inset-0,
.workspace-modal-overlay,
.modal-overlay {
  z-index: 12000;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-global-theme.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,uCAAuC;AACvC;;EAEE,qBAAqB;AACvB;;AAEA;;;;;EAKE,2CAA2C;AAC7C;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;;;;;EAKE,uCAAuC;AACzC;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;;;EAGE,oEAAoE;EACpE,qCAAqC;EACrC,2DAA2D;AAC7D;;AAEA;;EAEE,iEAAiE;AACnE;;AAEA,qCAAqC;AACrC;;;;;EAKE,6BAA6B;EAC7B,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;;;EAGE,8CAA8C;EAC9C,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;;;;EAIE,qCAAqC;EACrC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;;;;;;;EAOE,6BAA6B;EAC7B,2BAA2B;EAC3B,0CAA0C;EAC1C,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;;;EAGE,sFAAsF;EACtF,uFAAuF;EACvF,yCAAyC;AAC3C;;AAEA;;EAEE,sEAAsE;EACtE,uEAAuE;EACvE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;;;;EAIE,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;EAEE,8DAA8D;EAC9D,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;;;;EAIE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,2BAA2B;AAC3B;;;;;;;EAOE,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;0EAC0E;AAC1E;;EAEE,uCAAuC;AACzC;;AAEA,2EAA2E;AAC3E;;EAEE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;;;;;;;;;;;;;;;EAeE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA,4CAA4C;AAC5C;;EAEE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,6DAA6D;AAC7D;;;;;;;;;;;;;EAaE,wBAAwB;AAC1B;;AAEA;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,wDAAwD;AACxD;EACE,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;EAGE,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;;;EAGE,cAAc;AAChB","sourcesContent":["/**\n * SYSTEM-WIDE theme modernization for legacy product pages.\n * Applies design tokens to all dashboard surfaces so every page\n * inherits Midnight / Cloudlight without per-page rewrites.\n */\n\n/* ─── Universal product surfaces ─── */\n.rt2-main,\n.rt2-main * {\n  border-color: inherit;\n}\n\n.rt2-main .bg-white,\n.rt2-main .bg-gray-50,\n.rt2-main .bg-gray-100,\n.rt2-main .bg-slate-50,\n.rt2-main .bg-slate-100 {\n  background-color: var(--surface) !important;\n}\n\n.rt2-main .text-gray-900,\n.rt2-main .text-gray-800,\n.rt2-main .text-slate-900,\n.rt2-main .text-black {\n  color: var(--text-primary) !important;\n}\n\n.rt2-main .text-gray-700,\n.rt2-main .text-gray-600,\n.rt2-main .text-gray-500,\n.rt2-main .text-slate-600,\n.rt2-main .text-slate-500 {\n  color: var(--text-secondary) !important;\n}\n\n.rt2-main .border-gray-200,\n.rt2-main .border-gray-300,\n.rt2-main .border-slate-200 {\n  border-color: var(--border) !important;\n}\n\n.rt2-main .hover\\:bg-gray-50:hover,\n.rt2-main .hover\\:bg-gray-100:hover,\n.rt2-main .hover\\:bg-slate-50:hover {\n  background-color: var(--surface-hover) !important;\n}\n\n.rt2-main input:not([type='checkbox']):not([type='radio']):not([type='range']),\n.rt2-main select,\n.rt2-main textarea {\n  background-color: var(--input-background, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--input-border, var(--border)) !important;\n}\n\n.rt2-main input::placeholder,\n.rt2-main textarea::placeholder {\n  color: var(--input-placeholder, var(--text-secondary)) !important;\n}\n\n/* ─── Legacy buttons → RT look ─── */\n.rt2-main .navbar-button,\n.rt2-main .btn,\n.rt2-main button.secondary,\n.rt2-main .import-jira-btn,\n.rt2-main .create-project-btn {\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.rt2-main .navbar-button.primary,\n.rt2-main .btn-primary,\n.rt2-main .create-project-btn {\n  background: var(--primary, #2563eb) !important;\n  color: #fff !important;\n  border: 1px solid transparent !important;\n}\n\n.rt2-main .navbar-button.secondary,\n.rt2-main .btn-outline,\n.rt2-main .btn-secondary,\n.rt2-main .import-jira-btn {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border) !important;\n}\n\n.rt2-main .generate-all-scenarios-btn,\n.rt2-main .generate-all-tests-btn,\n.rt2-main .generate-tests-btn,\n.rt2-main .generate-scenarios-btn,\n.rt2-main .sync-btn,\n.rt2-main .view-tests-btn,\n.rt2-main .regenerate-btn {\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  border: 1px solid var(--border) !important;\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt2-main .generate-all-tests-btn,\n.rt2-main .generate-tests-btn,\n.rt2-main .sync-btn {\n  background: color-mix(in srgb, var(--primary, #2563eb) 14%, var(--surface)) !important;\n  border-color: color-mix(in srgb, var(--primary, #2563eb) 35%, var(--border)) !important;\n  color: var(--primary, #2563eb) !important;\n}\n\n.rt2-main .generate-all-scenarios-btn,\n.rt2-main .generate-scenarios-btn {\n  background: color-mix(in srgb, #f59e0b 12%, var(--surface)) !important;\n  border-color: color-mix(in srgb, #f59e0b 35%, var(--border)) !important;\n  color: #d97706 !important;\n}\n\n[data-theme=\"dark\"] .rt2-main .generate-all-scenarios-btn,\n[data-theme=\"dark\"] .rt2-main .generate-scenarios-btn {\n  color: #fbbf24 !important;\n}\n\n/* ─── Tables ─── */\n.rt2-main table,\n.rt2-main .projects-table,\n.rt2-main .workspaces-table,\n.rt2-main .schedule-table {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n.rt2-main thead,\n.rt2-main th {\n  background: var(--table-header, var(--bg-tertiary)) !important;\n  color: var(--text-secondary) !important;\n  border-color: var(--border) !important;\n}\n\n.rt2-main td {\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt2-main tbody tr:hover {\n  background: var(--table-hover, var(--surface-hover)) !important;\n}\n\n.rt2-main .projects-table-container,\n.rt2-main .table-container,\n.rt2-main .overflow-x-auto.rounded-lg,\n.rt2-main .overflow-x-auto {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n}\n\n/* ─── Cards / panels ─── */\n.rt2-main .card,\n.rt2-main .settings-card,\n.rt2-main .report-card,\n.rt2-main .metric-card,\n.rt2-main .rounded-md.bg-white,\n.rt2-main .rounded-lg.bg-white,\n.rt2-main .rounded-xl.bg-white {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  box-shadow: var(--shadow-sm) !important;\n  color: var(--text-primary) !important;\n}\n\n/* Elevation utilities: tint only — do NOT force borders onto every shadowed node\n   (that previously boxed text/labels that happened to carry shadow-sm). */\n.rt2-main .shadow-sm,\n.rt2-main .shadow {\n  box-shadow: var(--shadow-sm) !important;\n}\n\n/* ─── Status / priority pills keep semantic color but rest on tokens ─── */\n.rt2-main .status-tabs,\n.rt2-main .jira-items-tabs {\n  background: var(--surface) !important;\n  border-color: var(--border) !important;\n}\n\n.rt2-main .tab-btn,\n.rt2-main .status-tab {\n  color: var(--text-secondary) !important;\n}\n\n.rt2-main .tab-btn.active,\n.rt2-main .status-tab.active {\n  color: var(--primary, #2563eb) !important;\n}\n\n/* ─── Page-specific roots ─── */\n.schedule-plan-container,\n.environment-container,\n.environment-list,\n.test-data-list,\n.project-test-plan-container,\n.report-page-container,\n.reports-container,\n.learning-system,\n.optimization-container,\n.all-workspaces-container,\n.projects-container,\n.jira-items-overlay,\n.jira-items-container,\n.epics-stories-container,\n.requirement-upload-page {\n  background: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n}\n\n/* Environment / Test data Tailwind shells */\n.rt2-main .w-full.p-4.bg-white,\n.rt2-main .w-full.p-6.bg-white {\n  background: var(--surface) !important;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  color: var(--text-primary) !important;\n}\n\n/* ─── Embeds under PageScaffold: hide duplicate titles ─── */\n.rt-legacy-embed .projects-title,\n.rt-legacy-embed .projects-subtitle,\n.rt-legacy-embed .report-page-title,\n.rt-legacy-embed .report-title,\n.rt-legacy-embed .report-subtitle,\n.rt-legacy-embed .settings-header,\n.rt-legacy-embed .dashboard-welcome,\n.rt-legacy-embed .epics-stories-header h1,\n.rt-legacy-embed .epics-stories-header .epics-stories-subtitle,\n.rt-legacy-embed .requirement-upload-page > h1,\n.rt-legacy-embed .requirement-upload-page > .page-subtitle,\n.rt-projects-embed .projects-title,\n.rt-projects-embed .projects-subtitle {\n  display: none !important;\n}\n\n.rt-legacy-embed .jira-items-overlay,\n.rt-legacy-embed .jira-items-container {\n  position: relative !important;\n  top: auto !important;\n  left: auto !important;\n  right: auto !important;\n  bottom: auto !important;\n  z-index: auto !important;\n  height: auto !important;\n  min-height: 0 !important;\n  background: transparent !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.rt-legacy-embed .jira-items-container > .back-btn,\n.rt-legacy-embed .back-btn {\n  display: none !important;\n}\n\n/* Schedules: drop nested chrome + full-screen padding */\n.rt-schedules-embed > .bg-gray-50 {\n  background: transparent !important;\n  padding: 0 !important;\n  overflow: visible !important;\n}\n\n.rt-schedules-embed .min-h-screen {\n  min-height: 0 !important;\n}\n\n.rt-schedules-embed > .bg-gray-50 > .max-w-full > .bg-white.rounded-lg.shadow-sm.border.border-gray-200.mb-6:first-child {\n  display: none !important;\n}\n\n.rt-schedules-embed h1.text-xl,\n.rt-schedules-embed h1.text-2xl {\n  display: none !important;\n}\n\n/* Environments / Test Data: scaffold owns title + back */\n.rt-env-embed > div > button[data-testid='back-to-projects-btn'],\n.rt-env-embed h2.text-lg,\n.rt-testdata-embed h2.text-lg,\n.rt-env-form-embed > div > button,\n.rt-env-form-embed h1.text-2xl,\n.rt-env-form-embed h1 + p {\n  display: none !important;\n}\n\n.rt-env-embed > div.w-full,\n.rt-testdata-embed > div.w-full,\n.rt-env-form-embed > div.w-full {\n  padding: 0 !important;\n  box-shadow: none !important;\n  border: none !important;\n  background: transparent !important;\n}\n\n.rt-env-embed .flex.items-center.justify-between.mb-4 {\n  justify-content: flex-end;\n}\n\n.rt-workspaces-embed .workspaces-heading > h1,\n.rt-workspaces-embed .workspaces-heading > p {\n  display: none !important;\n}\n\n.rt-workspaces-embed .all-workspaces-container {\n  padding: 0 !important;\n  background: transparent !important;\n}\n\n/* Modals stay above shell */\n.rt2-main .fixed.inset-0,\n.workspace-modal-overlay,\n.modal-overlay {\n  z-index: 12000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
